<app-loading *ngIf="isLoading"></app-loading>

<div class="product-page" *ngIf="service && !isLoading">

  <section class="product-hero-card">

    <div class="product-media">

      @if(calcDis(getServicePrice(), service?.pricec) !== 0) {
        <div class="discountbadge">
          {{ calcDis(getServicePrice(), service?.pricec) }}%
          {{ "discount" | transloco }}
        </div>
      }

      <div class="product-image-card">
        @if(service?.image) {
          <img
            class="main-product-img"
            [defaultImage]="'/assets/imageloading.gif'"
            [lazyLoad]="fixImage(service.image)"
            [errorImage]="getFallbackImage()"
            alt="clinic service"
          />
        } @else {
          <img class="main-product-img" [src]="getFallbackImage()" alt="clinic service" />
        }
      </div>

    </div>

    <div class="product-summary">

      <button class="brand-link">
        {{ isAr ? "خدمة عيادة" : "Clinic Service" }}
      </button>

      <h1 class="product-title">
        {{ isAr ? service?.name_ar : service?.name_en }}
      </h1>



      <div class="price-box">
        <div class="price-row">
          <span class="new-price">
            {{ getServicePrice() }} {{ "egpe" | transloco }}
          </span>

          @if(calcDis(getServicePrice(), service?.pricec) !== 0) {
            <span class="old-price">
              {{ service?.pricec }} {{ "egpe" | transloco }}
            </span>
          }
        </div>
      </div>

      <div class="short-desc">
        {{ isAr ? service?.product_info_ar : service?.product_info_en }}
      </div>

      <div class="buy-box">


        <button class="btn-add-main" [routerLink]="['/book', service?.id]">
          {{ isAr ? "احجز الخدمة" : "Book Service" }}
        </button>
      </div>

    </div>

  </section>



</div>

<div class="empty-state" *ngIf="!service && !isLoading">
  <img src="/assets/noproduct.png" alt="empty">
  <h3>
    {{ isAr ? "الخدمة غير موجودة" : "Service not found" }}
  </h3>
</div>